// 常用类型检测

export function is(data, type) {
  return Object.prototype.toString.call(data) === `[object ${type}]`
}

export function isObject(val) {
  return val !== null && is(val, 'Object')
}

export function isNumber(val) {
  return typeof val === 'number'
}

export function isPromise(val) {
  return (
    is(val, 'Promise') &&
    isObject(val) &&
    isFunction(val.then) &&
    isFunction(val.catch)
  )
}

export function isString(val) {
  return typeof val === 'string'
}

export function isFunction(val) {
  return typeof val === 'function'
}

export function isBoolean(val) {
  return typeof val === 'boolean'
}

export function isRegExp(val) {
  return is(val, 'RegExp')
}

export function isEmptyObject(obj) {
  for (const _ in obj) {
    return false
  }
  return true
}

export function isArray(data) {
  return is(data, 'Array')
}

export function isUndefined(data) {
  return data === undefined
}

export function isNull(data) {
  return data === null
}

export function isEmpty(data) {
  return data === undefined || data === null
}

export function isEmptyArray(data) {
  return !isArray(data) || data.length === 0
}

export function isLikeFalse(data) {
  return !data
}
